export default __webpack_public_path__ + "images/a12ab107af40ccdbe1f7cfacb61a8851.svg";